module.exports = __webpack_public_path__ + "img/bg2.6c7dac11.jpg";